import store from '@/store'
export default [
  {
    path: '/attendance-settings',
    name: 'attendance-setting',
    meta: { requiresAuth: true },
    component: () => import('@/pages/attendance-setting/index.vue')
  }
]
